import { ForwardedRef, ReactNode, forwardRef } from "react";
import classNames from "classnames";
import styled from "styled-components";

interface ScrimProps {
  $expanded: boolean;
}

const Scrim = styled.div<ScrimProps>`
  position: fixed;
  top: 7.125rem;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3); // adjust opacity as needed
  z-index: 0; // make sure it's below the menu but above other content
  opacity: ${(props) => (props.$expanded ? 1 : 0)};
  visibility: ${(props) => (props.$expanded ? "visible" : "hidden")};
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease;
  pointer-events: ${(props) => (props.$expanded ? "auto" : "none")};
`;

/** The `FullWidthDropdownMenu` component properties.  */
export interface MenuProps {
  /** Indicates whether the menu is expanded or not. */
  readonly expanded: boolean;

  /** The component children. */
  readonly children?: ReactNode;
}

/** The menubar menu. */
export const FullWidthDropdownMenu = forwardRef((props: MenuProps, ref: ForwardedRef<HTMLDivElement>): ReactNode => {
  const { expanded, children } = props;
  const className = classNames("menu", { expanded });

  return (
    <>
      <div style={{ zIndex: 100 }} ref={ref} tabIndex={-1} className={className}>
        {children}
      </div>
      <Scrim $expanded={expanded} />
    </>
  );
});
